import PhoneInput from "react-phone-input-2";
import type { ComponentProps } from "react";
import "react-phone-input-2/lib/style.css";

type PhoneInputProps = ComponentProps<typeof PhoneInput>;

export default function PhoneInputField(props: PhoneInputProps) {
  return <PhoneInput countryCodeEditable={false} {...props} />;
}
